module.exports = __webpack_public_path__ + "img/about_con_2-2.2089ac1b.png";